export interface Destructor {
    (): void;
}

export function createElementDestructor(parent: Element, child: Element, finalizer?: (child: Element) => void): Destructor {
    const parentRef = new WeakRef(parent)
    const childRef = new WeakRef(child)

    return () => {
        const node = parentRef.deref()
        if (!node) {
            return
        }

        const childNode = childRef.deref()
        if (!childNode) {
            return
        }

        if (finalizer) {
            finalizer(childNode)
        }

        node.removeChild(childNode)
    }
}

export function createDestructor<T extends object>(value: T, finalizer: (value: T) => void): Destructor {
    const ref = new WeakRef<T>(value)

    return () => {
        const refValue = ref.deref()
        if (!refValue) {
            return
        }

        finalizer(refValue)
    }
}
